import './vision-upgrade.scss';
import UpgradeFlowCtrl from '../upgrade/upgrade-flow-ctrl';

export default class VisionApiPlansDialogCtrl extends UpgradeFlowCtrl {

    // @ngInject
    constructor($scope, $q, $mdDialog, signupDataStore, authData, authService, ProductsResource, cvapi) {

        super($q, $mdDialog, signupDataStore, authData, authService, ProductsResource);
        this.$mdDialog = $mdDialog;
        this.$scope = $scope;

        this.plans = cvapi.plans;
        this.currentPlan = cvapi.current;
        this.newPlan = cvapi.selected;
        this.billingCompleted = cvapi.billingCompleted;
        this.newId = this.newPlan.id;
        this.$scope.$watch('apiPlans.newId', this.changeSelected());
    }

    changeSelected() {
        return (value) => {
            this.newPlan = this.plans.find((plan) => {
                return plan.id === parseInt(value, 10);
            });
        };
    }

    isUpgradeButtonDisabled() {

        if (this.newPlan === undefined) {
            return true;
        }

        const newPlanId = parseInt(this.newPlan.id, 10);
        if (this.billingCompleted) {
            return this.newPlan.free;
        }

        return newPlanId === this.currentPlan.id;
    }

    startUpgradeFlow() {
        this.signupDataStore.upgrade.plan = this.newPlan;
        this.signupDataStore.upgrade.stage = this.currentPlan.free ? 'payment' : 'review';
    }

    hide() {
        this.$mdDialog.cancel();
        this.signupDataStore.clearPaymentDetails();
    }

    cancelSubscription() {
        this.signupDataStore.upgrade.stage = 'vision-cancel';
    }
}



// WEBPACK FOOTER //
// ./user/visionapi/vision-api-plans-ctrl-dialog.js